// Validator.email no valida correctamente "correo@correo"
export const expRegEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
